
   
/**
 *
 * @returns check its login or not with boolean status
 */
 export const isLogin = () => {
    const token = localStorage.getItem("signinToken");
  
    if (token) {
      return true;
    } else {
      return false;
    }
  };